export default __webpack_public_path__ + "static/media/in-as.352f0b5f.svg";